import { useTranslations } from 'next-intl';
import useActualLocale from './useActualLocale';

export const useLocale = useActualLocale;

export { useTranslations };
